<ra-modal [title]="'order.members.title' | translate" (close)="close.emit()">
    @if (loading()) {
        <div class="container-loading">
            <ra-loading [message]="'order.members.loading' | translate"/>
        </div>
    }
    @else {
        <div class="modal-content">
            <!-- Description -->
            <p class="ra-label-s description-message">{{ 'order.members.hint' | translate }}</p>

            <!-- Explica o que significa ser membro do serviço -->
            <div class="members-info">
                <ra-icon icon="info-circle" varColor="primary" [size]="16" />
                <p class="ra-label-xs">{{ 'order.members.info' | translate }}</p>
            </div>

            @if (members().length == 0) {
                <div class="container-empty">
                    <ra-empty [marginTop]="24" [message]="'order.members.emptyMessage' | translate"/>
                </div>
            }
            @else {
                <!-- Members list -->
                <div class="container-members-list">
                    @for (member of members(); track member._id) {
                        <div class="member-item">
                            <div class="member-left">
                                <div class="member-info">
                                    <ra-user-avatar [user]="member" [avatarSize]="28" />

                                    <!-- Name and email -->
                                    <div class="member-name-email">
                                        <p class="ra-label-s">
                                            {{ member.name }}
                                            @if (member._id === currentUserId) {
                                                <span class="you-badge">{{ 'order.members.you' | translate }}</span>
                                            }
                                        </p>
                                        <p class="ra-label-xs content-secondary">{{ member.email }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Switch à direita; salva na hora (travado durante a requisição) -->
                            <ra-switch
                                [formControl]="getMemberControl(member._id)"
                                [disabled]="savingIds().has(member._id)"
                            />
                        </div>
                    }
                </div>
            }

        </div>
    }
</ra-modal>
